<div class="sentiment-details-heatmap">
  <div class="sentiment-details-heatmap__header" *ngIf="!hideHeader">
    <h4 class="sentiment-details-heatmap__title">Heatmap</h4>
    <div class="sentiment-details-heatmap__filters">
      <select
        class="sentiment-details-heatmap__select"
        [value]="cohortType"
        [disabled]="resolvedCohortOptions.length === 0"
        (change)="onCohortChange($any($event.target).value)"
      >
        <option *ngIf="resolvedCohortOptions.length === 0" value="" disabled>No cohort filters configured</option>
        <option *ngFor="let o of resolvedCohortOptions" [value]="o.value">{{ o.label }}</option>
      </select>
      <select
        class="sentiment-details-heatmap__select"
        [value]="level"
        (change)="onLevelChange($any($event.target).value)"
      >
        <option *ngFor="let o of levelOptions" [value]="o.value">{{ o.label }}</option>
      </select>
      <select
        class="sentiment-details-heatmap__select"
        [value]="sentimentType"
        (change)="onSentimentChange($any($event.target).value)"
      >
        <option *ngFor="let o of sentimentOptions" [value]="o.value">{{ o.label }}</option>
      </select>
    </div>
  </div>
  <div class="sentiment-details-heatmap__body" *ngIf="loading">
    <p class="sentiment-details-heatmap__loading">Loading heatmap...</p>
  </div>
  <div class="sentiment-details-heatmap__split" *ngIf="!loading && hasData">
    <div class="sentiment-details-heatmap__split-pinned">
      <table class="sentiment-details-heatmap__table sentiment-details-heatmap__table--pinned">
        <colgroup>
          <col class="sentiment-details-heatmap__col sentiment-details-heatmap__col--row" />
          <col class="sentiment-details-heatmap__col sentiment-details-heatmap__col--total" />
        </colgroup>
        <thead>
          <tr>
            <th class="sentiment-details-heatmap__th sentiment-details-heatmap__th--row">{{ rowHeaderLabel }}</th>
            <th class="sentiment-details-heatmap__th sentiment-details-heatmap__th--total" title="Responses in this row (all cohorts)">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableRows">
            <td
              class="sentiment-details-heatmap__td sentiment-details-heatmap__td--row sentiment-details-heatmap__td--row-click sentiment-details-heatmap__td--truncate"
              [class.sentiment-details-heatmap__td--selected]="isRowScopeSelected(row.rowLabel)"
              (click)="onRowClick(row, $event)"
              [attr.title]="row.rowLabel + ' — Click to view all customer feedback for this row'"
            >
              {{ row.rowLabel }}
            </td>
            <td
              class="sentiment-details-heatmap__td sentiment-details-heatmap__td--total sentiment-details-heatmap__td--row-click"
              [class.sentiment-details-heatmap__td--selected]="isRowScopeSelected(row.rowLabel)"
              (click)="onRowClick(row, $event)"
              title="View all customer feedback for this row"
            >
              {{ formatRowTotal(row.rowTotal) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="sentiment-details-heatmap__split-scroll">
      <table class="sentiment-details-heatmap__table sentiment-details-heatmap__table--cohorts">
        <thead>
          <tr>
            <th
              *ngFor="let col of tableRows[0]?.cells"
              class="sentiment-details-heatmap__th sentiment-details-heatmap__th--cell sentiment-details-heatmap__th--truncate"
              [class.sentiment-details-heatmap__th--selected-col]="isCohortColumnSelected(col)"
              [attr.title]="col.label"
            >
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableRows">
            <td
              *ngFor="let cell of row.cells"
              class="sentiment-details-heatmap__td sentiment-details-heatmap__td--cell sentiment-details-heatmap__td--clickable"
              [class.sentiment-details-heatmap__td--dark]="isCellDark(row.rowLabel, cell)"
              [class.sentiment-details-heatmap__td--selected]="isCohortCellSelected(row.rowLabel, cell)"
              [style.background-color]="getCellColor(row.rowLabel, cell)"
              (click)="onCellClick(row.rowLabel, cell)"
            >
              {{ formatCellText(cell) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="sentiment-details-heatmap__empty" *ngIf="!loading && !hasData">
    <p>No heatmap data. Try changing filters or ensure sufficient responses.</p>
  </div>
</div>
